/**
 * Плитка показателя: трафик, устройства и прочее в две-три колонки.
 */
import type { ReactNode } from 'react';

import { Icon, type IconName } from './Icon';
import styles from './Stat.module.css';

export function StatGrid({ children }: { children: ReactNode }) {
  return <div className={styles.grid}>{children}</div>;
}

export function Stat({ icon, value, label }: { icon: IconName; value: ReactNode; label: string }) {
  return (
    <div className={styles.stat}>
      <span className={styles.icon}>
        <Icon name={icon} size={18} />
      </span>
      <div className={styles.value}>{value}</div>
      <div className={styles.label}>{label}</div>
    </div>
  );
}
